import {DossierT50, DossierDate} from "./base.model";

export class MigrationCardInfoType {
  series?: DossierT50 = '';
  number?: DossierT50 = '';
  dateStart: DossierDate = '';
  dateEnd: DossierDate = '';
}
